/**
* Controller for the standalone task form page
* @author Brendan Magee
*/

function StandaloneTaskFormController(
  $scope,
  $log,
  $location,
  $translate,
  Task,
  toastWrapperService
) {
  // The magic number below comes from the lengh of `/tasks/new?storyID=` and `/task-form?storyID=`,
  // which happen to be identical. If the routes change, the logic will likely need to be altered.

  const basePathLength = 19;
  const locationUrl = $location.url();

  const urlStoryID = locationUrl.slice(basePathLength) || null;

  function cleanUpStoryId(id) {
    const encodedID = decodeURIComponent(id);
    return decodeURIComponent(encodedID);
  }

  function getStoryId(id) {
    if (id) {
      return cleanUpStoryId(id);
    }
    return null;
  }

  $scope.task = {
    storyID: getStoryId(urlStoryID)
  };

  $scope.$on('task-created', ($event) => {
    $event.stopPropagation();
    toastWrapperService.createToast($translate.instant('TASK_CREATED'), 'success');
  });
}

const ctrlArray = [
  '$scope',
  '$log',
  '$location',
  '$translate',
  'Task',
  'toastWrapperService',
  StandaloneTaskFormController
];

export default function (ngModule) {
  ngModule.controller('StandaloneTaskFormController', ctrlArray);
}
